// Basic components
import Accordion from '../accordion/theme';
import Avatar from '../avatar/theme';
import Badge from '../badge/theme';
import Box from '../box/theme';
import Breadcrumbs from '../breadcrumbs/theme';
import Button from '../button/theme';
import Card from '../card/theme';
import Checkbox from '../checkbox/theme';
import Dialog from '../dialog/theme';
import Divider from '../divider/theme';
import DragAndDrop from '../dragAndDrop/theme';
import Footer from '../footer/theme';
import Grid from '../grid/theme';
import Header from '../header/theme';
import Heading from '../heading/theme';
import Icon from '../icon/theme';
import Image from '../image/theme';
import Input from '../input/theme';
import Link from '../link/theme';
import List from '../list/theme';
import Menu from '../menu/theme';
import Message from '../message/theme';
import Modal from '../modal/theme';
import Notification from '../notification/theme';
import P from '../p/theme';
import Pagination from '../pagination/theme';
import Panel from '../panel/theme';
import Popover from '../popover/theme';
import Progress from '../progress/theme';
import ProgressCircular from '../progressCircular/theme';
import Radio from '../radio/theme';
import Select from '../select/theme';
import Sidemenu from '../sidemenu/theme';
import Skeleton from '../skeleton/theme';
import Spinner from '../spinner/theme';
import Switch from '../switch/theme';
import T from '../t/theme';
import Table from '../table/theme';
import Tabs from '../tabs/theme';
import Tag from '../tag/theme';
import Textarea from '../textarea/theme';
import Tree from '../tree/theme';
import themePlaceholder from './themePlaceholder';
// Official external components
const Markdown = themePlaceholder;
const MarkdownEditor = themePlaceholder;
export default {
    Accordion,
    Avatar,
    Badge,
    Box,
    Breadcrumbs,
    Button,
    Card,
    Checkbox,
    Dialog,
    Divider,
    DragAndDrop,
    Footer,
    Grid,
    Header,
    Heading,
    Icon,
    Image,
    Input,
    Link,
    List,
    Markdown,
    MarkdownEditor,
    Menu,
    Message,
    Modal,
    Notification,
    P,
    Pagination,
    Panel,
    Progress,
    ProgressCircular,
    Popover,
    Radio,
    Select,
    Sidemenu,
    Skeleton,
    Spinner,
    Switch,
    T,
    Table,
    Tabs,
    Tag,
    Textarea,
    Tree
};
